// gatsby-browser.js
export const onClientEntry = () => {
  if (typeof window === "undefined") return;

  const jquery = document.createElement("script");
  jquery.src = "https://code.jquery.com/jquery-3.6.0.min.js";
  jquery.async = false;

  jquery.onload = () => {
    const colorbox = document.createElement("script");
    colorbox.src = "/js/jquery.colorbox.js?ver=1.0.0";
    colorbox.async = false;

    colorbox.onload = () => {
      const docready = document.createElement("script");
      docready.src = "/js/docready.js?ver=1.0.0";
      docready.async = false;
      document.body.appendChild(docready);
    };

    document.body.appendChild(colorbox);
  };

  document.body.appendChild(jquery);
};
